export default "__VITE_ASSET__1c55f94c__"